import { createStyles, makeStyles } from "@material-ui/core";
import * as React from "react";

import { RelodeTheme, Text } from "../../..";

type MarketResearchSectionProps = {
    children?: React.ReactNode;
    actions?: React.ReactNode;
    title: string;
    id: string;
};

const useMarketResearchSectionStyle = makeStyles(
    (theme: RelodeTheme) =>
        createStyles({
            header: {
                display: "grid",
                gridTemplateColumns: "1fr auto",
            },
            paper: {
                padding: theme.spacing(5),
            },
            root: {
                marginBottom: theme.spacing(1),
            },
            actions: {
                display: "grid",
                gridTemplateColumns: "1fr",
                gridAutoFlow: "column",
            },
        }),
    { name: "MarketResearchSection" }
);

export const MarketResearchSection = (props: MarketResearchSectionProps) => {
    const { children, title, actions, id } = props;
    const classes = useMarketResearchSectionStyle(props);
    return (
        <div className={classes.root} id={id}>
            <div className={classes.header}>
                {!!title ? (
                    <Text variant="h2" gutterBottom>
                        {title}
                    </Text>
                ) : null}
                {!!actions ? (
                    <div className={classes.actions}>{actions}</div>
                ) : null}
            </div>
            {children}
        </div>
    );
};
